import { EnvironmentSettings, IEnvironmentSettings } from "./environmentSettings";
import { GetAuthSetting , IAuthSettings } from "./authSettings";
import { GetServiceSettings, IServiceSettings } from "./serviceSettings";

export interface IApplicationSettings {
    authSettings: IAuthSettings;
    environmentSettings: IEnvironmentSettings;
    serviceSettings: IServiceSettings;
}

const environment: IEnvironmentSettings = EnvironmentSettings();

export const GetApplicationSetting: IApplicationSettings = {
    authSettings: GetAuthSetting(environment.environment),
    environmentSettings: environment,
    serviceSettings: GetServiceSettings(environment.environment),
}